import axios from "../../config/axiosConfig";
import { GET_PRODUCTION_TRANSACTIONS, PRODUCTION_TRANSACTION_REQUEST, PRODUCTION_TRANSACTION_REQUEST_FAILURE, GET_PRODUCTION_TRANSACTIONS_TAKA_NO,
  GET_PRODUCTION_TRANSACTIONS_BY_BEAM, SET_SELECTED_BEAM, GET_PRODUCTION_TRANSACTIONS_WITH_SPECIFIC_COLUMNS
 } from "../types";

export const getProductionTransaction = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getAllProductionTransactionsWithSpecificColumns = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (include) {
        const includeAttributes = ["Production_Id", "Challan_T_Id"].join(',');
        params = { ...params, include, includeAttr: includeAttributes };
      }
      return axios.get("/production-transaction/getAllTransactionsWithSpecificColumns", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_TRANSACTIONS_WITH_SPECIFIC_COLUMNS, payload: { ...(response?.data) } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getProductionTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-transaction/getAllTransactionTakaNos", { params }).then((response) => {
        const takaNos = response.data.map((data) => ({
          Taka_No: data.Taka_No,
          Book_Id: data?.Production?.Book_Id,
          Account_Id: data?.Production?.Account_Id,
          Type: data?.Production_Type,
          Voucher_No: data?.Production?.Vch_No,
        }));
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getProductionTransactionsByBeam = (beamId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/production-transaction/getTakaByBeam/${beamId}`, { params }).then((response) => {
        console.log('<<Beam-Taka--', response);
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_TRANSACTIONS_BY_BEAM, payload: response.data });
        }
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_TRANSACTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
}

export const setSelectedBeamInProduction = (beamId) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_SELECTED_BEAM, payload: beamId });
  };
}

